import { styled } from '../../../../modules';

const qiTechBlue = '#1c49a5';
// Shared lighter text tone for the message copy (headlines + redirect note).
const messageColor = '#4a5568';

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
`;

export const Header = styled.header`
    width: 100%;
    background-color: ${qiTechBlue};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 24px;
    min-height: 80px;
`;

export const HeaderLogo = styled.img`
    max-height: 40px;
    max-width: 180px;
    object-fit: contain;
`;

export const Content = styled.div<{ $hasAmount: boolean }>`
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: ${({ $hasAmount }) => ($hasAmount ? '24px 24px 8px' : '48px 24px 24px')};
`;

export const Headline = styled.p<{ $small?: boolean }>`
    font-size: ${({ $small }) => ($small ? '17px' : '21px')};
    font-weight: 500;
    line-height: 1.35;
    color: ${messageColor};
    margin: 0;

    em {
        font-style: normal;
        font-weight: 800;
        color: ${messageColor};
    }
`;

export const Amount = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 6px;
    margin: 16px 0;
    color: ${qiTechBlue};
    font-weight: 800;
    line-height: 1;
    font-variant-numeric: tabular-nums;
`;

export const AmountCurrency = styled.span`
    font-size: 25px;
    font-weight: 700;
    opacity: 0.85;
`;

export const AmountValue = styled.span`
    font-size: 54px;
    letter-spacing: -1px;
`;

export const RedirectMessage = styled.p`
    /* Typography matches Headline ($small) so this reads as a continuation
       of "está pronta para assinatura"; only the top margin differs (spacing). */
    margin: 24px 0 0;
    padding-top: 24px;
    font-size: 17px;
    font-weight: 500;
    line-height: 1.35;
    color: ${messageColor};
`;

export const PartnerName = styled.span<{ $color: string }>`
    font-weight: 700;
    color: ${({ $color }) => $color};
`;

export const Text = styled.p`
    font-size: 24px;
    font-weight: 400;
    line-height: 1.4;
    color: #555555;
    margin: 0 0 16px;
`;

export const SubText = styled.p`
    font-size: 18px;
    font-weight: 400;
    line-height: 1.5;
    color: #555555;
    margin: 0;

    strong {
        font-weight: 700;
    }
`;

export const BottomSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 24px 24px;
`;

export const PartnerLogo = styled.img`
    max-height: 64px;
    max-width: 220px;
    object-fit: contain;
    align-self: flex-start;
`;

export const ContinueButton = styled.button<{ $backgroundColor: string }>`
    width: 100%;
    padding: 16px 20px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    background-color: ${({ $backgroundColor }) => $backgroundColor};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;

export const PoweredByContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 8px;
`;
